"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtuPerHourPerSquareFeetPerFahrenheit = exports.WattPerSquareMeterPerKelvin = void 0;
var UnitDivide = require("../unit-divide");
var power_1 = require("./power");
var area_1 = require("./area");
var delta_temperature_1 = require("./delta-temperature");
// Thermal Transmittance
exports.WattPerSquareMeterPerKelvin = UnitDivide.intensityByDeltaTemperature("WattPerSquareMeterPerKelvin", UnitDivide.powerByArea("", power_1.Watt, area_1.SquareMeter), delta_temperature_1.DeltaCelsius);
exports.BtuPerHourPerSquareFeetPerFahrenheit = UnitDivide.intensityByDeltaTemperature("BtuPerHourPerSquareFeetPerFahrenheit", UnitDivide.powerByArea("", power_1.BtuPerHour, area_1.SquareFeet), delta_temperature_1.DeltaFahrenheit);
//# sourceMappingURL=thermal-transmittance.js.map